import { createTypes } from 'reduxsauce';

export default createTypes(
    `
    SET_USER
`,
    {
        prefix: 'user/'
    }
);
